var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import { H4 } from "@irati/ui/src/Typography";
import Flex from "@irati/ui/src/Flex";
var DateOfBirthRequiredBlock = /** @class */ (function (_super) {
    __extends(DateOfBirthRequiredBlock, _super);
    function DateOfBirthRequiredBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateOfBirthRequiredBlock.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(H4, { textAlign: "center", marginBottom: 2 },
                React.createElement(FormattedMessage, { id: "perks.redemptionEvents.dateOfBirthRequiredBlock.header", values: {
                        boldText: (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            React.createElement("strong", null,
                                React.createElement(FormattedMessage, { id: "perks.redemptionEvents.dateOfBirthRequiredBlock.boldText" }))))
                    } })),
            React.createElement(Flex, { justifyContent: "center" },
                React.createElement(ButtonRouterLink, { to: "/", app: this.context.apps.ACCOUNT },
                    React.createElement(FormattedMessage, { id: "perks.redemptionEvents.dateOfBirthRequiredBlock.buttonText" })))));
    };
    DateOfBirthRequiredBlock.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return DateOfBirthRequiredBlock;
}(PureComponent));
export default injectIntl(DateOfBirthRequiredBlock);
